module.exports = __webpack_public_path__ + "img/pageright.f4f0ffed.svg";